import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";

import { useViewport } from "assets/js/hooks/useViewport";
import breakpoints from "core/breakpoints";
import {
    LOADING_MODE,
    MAX_QUEUE_MODE,
    MAX_TIME_MODE,
    INCOMPLETE_ACCOUNT_MODE,
    CONFIRM_MODE,
    UPLOAD_MODE,
    getPath
} from "./helpers";

import Loading from "./Loading";
import MobileError from "./Errors/Mobile";
import MaxQueueError from "./Errors/MaxQueue";
import MaxTimeError from "./Errors/MaxTime";
import AccountError from "./Errors/Account";
import Confirmation from "./Confirmation";
import PhotoUpload from "./PhotoUpload";

const PhotoUploadPage = () => {
    const history = useHistory();
    const [mode, setMode] = useState(UPLOAD_MODE); // todo future PR: revert to LOADING_MODE
    const { browserWidth } = useViewport();
    const isMobile = browserWidth < breakpoints.tablet.px;

    // TODO: Query backend for account status, queue & 30-day limits

    // NOTE: We update the URL for google analytics tracking
    useEffect(() => {
        const desiredPath = getPath(mode);
        if (desiredPath && history.location.pathname !== desiredPath) {
            window.history.replaceState(null, null, desiredPath); // update URL without rendering component again
        }
    }, [mode]);

    // TODO:
    // - Run checks for incomplete account, max queue, or max time
    // - If user has both max-queue & max-time, show max-queue
    // - Once mode determined, use setMode() to transition from loading state

    // Mobile check
    if (isMobile) {
        return <MobileError />;
    }

    switch (mode) {
        case LOADING_MODE:
            return <Loading />;
        case MAX_QUEUE_MODE:
            return <MaxQueueError />;
        case MAX_TIME_MODE:
            return <MaxTimeError daysRemaining={30} />;
        case INCOMPLETE_ACCOUNT_MODE:
            return <AccountError missingName missingEmail />;
        case CONFIRM_MODE:
            return <Confirmation />;
        default:
            return <PhotoUpload />;
    }
};

export default PhotoUploadPage;
